import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
	IState,
	factcheckSearchProviderFeatureKey,
} from './factcheck-search-provider.reducers';

const selectFeature = createFeatureSelector<IState>(
	factcheckSearchProviderFeatureKey,
);

const selectProviders = createSelector(
	selectFeature,
	(state) => state.providers,
);

const selectLanguages = createSelector(
	selectFeature,
	(state) => state.languages,
);

const selectRouting = createSelector(selectFeature, (state) => state.routing);

const selectLoading = createSelector(selectFeature, (state) => state.loading);

const selectError = createSelector(selectFeature, (state) => state.error);

const selectPendingChanges = createSelector(
	selectFeature,
	(state) => state.pendingChanges,
);

export const FactcheckSearchProviderSelectors = {
	selectProviders,
	selectLanguages,
	selectRouting,
	selectLoading,
	selectError,
	selectPendingChanges,
};
